import { CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ArtigosFacturacao } from 'app/shared/models/artigos/artigosfacturacao';
import { ClienteFacturacao } from 'app/shared/models/clientes/clientefacturacao';
import { Empresa } from 'app/shared/models/empresa/empresa';
import { Documentos } from 'app/shared/models/financas/documentos/documentos';
import { DocumentosTipos } from 'app/shared/models/financas/documentos/documentosTipos';
import { Util } from 'app/shared/models/generico/util';
import { CalculosFinancasService } from 'app/shared/services/Calculos/calculos-financas.service';
import { NotificacaoService } from 'app/shared/services/notificacao/notificacao.service';
import { ModalPesquisaArtigosFaComponent } from 'app/views/facturacao/modais/modal-pesquisa-artigos-fa/modal-pesquisa-artigos-fa.component';

@Component({
  selector: 'app-tabela-itens-fin',
  templateUrl: './tabela-itens-fin.component.html',
  styleUrls: ['./tabela-itens-fin.component.scss'],
  providers: [CurrencyPipe],
})
export class TabelaItensFinComponent implements OnInit {
  
  @Output() alteracaoDados = new EventEmitter();

  empresa: Empresa = {};
  facturaForm: FormGroup;
  conversaoDirecta = false;
  artigosFA: ArtigosFacturacao[] = [];
  artigosFAAutoComplete: ArtigosFacturacao[] = [];
  tiposDocumentos: DocumentosTipos[] = [];
  cliente: ClienteFacturacao | null;
  docCorrenteTemp: Documentos;
  codMoedaPrincipalCliente: string;
  gereStocks: any;
  docCorrente: Documentos;
  modoDocPorRef = false;
  idTipoOperacao = 1;

  get Itens(): FormArray {
    return this.facturaForm.get("Itens") as FormArray;
  }
  constructor(private fb: FormBuilder,  public _doccalculoFront: CalculosFinancasService,
    private currencyPipe: CurrencyPipe,
    private modal: MatDialog,
    private _notificacao: NotificacaoService,
    ) {     this.inicializarFormulario()
    }

  ngOnInit(): void {
  }
  inicializarFormulario(documento?: Documentos): void {
    this.facturaForm = this.fb.group({
      Itens: this.fb.array([]),})
  }

  async calcularValoresItem(index: number) {
    const itens = await this.alterarValoresIdItem(this.Itens.value);

    const Totais = {
      ConversaoDirecta: this.conversaoDirecta,
      TaxaCambio: this.facturaForm.value.TaxaCambio,
    };

    const modelo = {
      item: itens[index],
      itens,
      Totais,
    };
    this.calcularValoresItemTotaisFront(modelo, index);
  }

  calcularValoresItemTotaisFront(modelo:any, index:number) {
    const resultado = this._doccalculoFront.CalcularValoresItem(modelo);
    const dados = resultado.totais;
    const linha = resultado.item;
    this.alterarLinhaItem(linha, index);
    if (linha.descontoPerc > 100) {
      this.Itens.controls[index]
        .get("DescontoPerc")
        .setValue(
          this.currencyPipe.transform(Util.convertToFloat(100), "", "")
        );
    }
  }
  pesquisarArtigos(event, index: number) {
    event.stopPropagation();
    const tipoDoc = this.tiposDocumentos.find(
      (x) =>
        x.idTipoDocumento ===
        parseInt(this.facturaForm.get("IdTipoDocumento").value, 10)
    );
    const modalRef = this.modal.open(ModalPesquisaArtigosFaComponent, {
      width: "90vw",
      maxWidth: "90vw",
      data: {
        msg: "Pesquisa de Artigos",
        empresa: this.empresa,
        tipoDocumento: tipoDoc,
        artigosFA: this.artigosFA,
        gereStock: this.gereStocks,
      },
    });

      modalRef.afterClosed().subscribe((res) => {
        if (res && res.itens) {
          if (res.itens[0].idArtigo > 0) {
            this.selecArtigo(res.itens[0], index);
          }
          if (index >= this.Itens.controls.length - 1) {
            this.addItemsFactura(1);
          }
        }
      });
  }

  async addItemsFactura(totalItems: number) {
    for (let i = 0; i < totalItems; i++) {
      this.Itens.push(await this.criarItems(null, i));
    }
  }

  async criarItems(item?: any, idItem?: number): Promise<FormGroup> {
    if (item?.idIva) {
      item["idImposto"] = item?.idIva ? item?.idIva : "";
      item["taxaImposto"] = item?.taxaImposto ? item?.taxaImposto : "";
    }

    return await this.fb.group({
      IdArtigo: [item && item.idArtigo ? item.idArtigo : 0],
      IdItem: [item && item.idItem ? item.idItem : idItem],
      IdItemDocRef: [item && item.idItemDocRef ? item.idItemDocRef : null],
      CodArtigo: [item && item.codArtigo ? item.codArtigo : ""],
      geridoPorStocks: [
        item && item.geridoPorStocks ? item.geridoPorStocks : false,
      ],
      valorgeridoPorStocks: [
        item && item.geridoPorStocks ? (item.geridoPorStocks ? "S" : "N") : "",
      ],
      Descricao: [item && item.descricao ? item.descricao : ""],
      CodUnidade: [item && item.codUnidade ? item.codUnidade : ""],
      IdImposto: [item && item.idImposto ? item.idImposto : 0],
      taxaImposto: [item && item.taxaImposto ? item.taxaImposto : null],
      IdDocumento: [item && item.idDocumentoItem ? item.idDocumentoItem : 0],
      CodIva: [item && item.codIVA ? item.codIVA : ""],
      DescricaoIva: [item && item.descricaoIva ? item.descricaoIva : ""],
      PrecoME: [
        item && item.precoME
          ? this.currencyPipe.transform(
              Util.convertToFloat(item.precoME),
              "",
              ""
            )
          : this.currencyPipe.transform(0, "", ""),
      ],
      Quantidade: [
        item && item.quantidade
          ? this.currencyPipe.transform(
              Util.convertToFloat(item.quantidade),
              "",
              ""
            )
          : this.currencyPipe.transform(1, "", ""),
      ],
      DescontoPerc: [
        item && item.descontoPerc
          ? this.currencyPipe.transform(
              Util.convertToFloat(item.descontoPerc),
              "",
              ""
            )
          : this.currencyPipe.transform(0, "", "")],
      Desconto: [
        item && item.desconto
          ? this.currencyPipe.transform(
              Util.convertToFloat(item.desconto),
              "",
              ""
            )
          : this.currencyPipe.transform(0, "", ""),
      ],
      imposto: [
        item && item.imposto
          ? this.currencyPipe.transform(
              Util.convertToFloat(item.imposto),
              "",
              ""
            )
          : this.currencyPipe.transform(0, "", ""),
      ],
      Preco: [
        item && item.preco
          ? this.currencyPipe.transform(Util.convertToFloat(item.preco), "", "")
          : this.currencyPipe.transform(0, "", ""),
      ],
      Total: [
        item && item.total
          ? this.currencyPipe.transform(Util.convertToFloat(item.total), "", "")
          : this.currencyPipe.transform(0, "", ""),
      ],
      TotalGeral: [
        item && item.totalGeral
          ? this.currencyPipe.transform(
              Util.convertToFloat(item.totalGeral),
              "",
              ""
            )
          : this.currencyPipe.transform(0, "", ""),
      ],
      ImpostoRetido: [
        item && item.impostoRetido
          ? this.currencyPipe.transform(
              Util.convertToFloat(item.impostoRetido),
              "",
              ""
            )
          : this.currencyPipe.transform(0, "", ""),
      ],
      SubTotal: [
        item && item.subTotal
          ? this.currencyPipe.transform(
              Util.convertToFloat(item.subTotal),
              "",
              ""
            )
          : this.currencyPipe.transform(0, "", ""),
      ],
      Separador: [item ? item.texto : false],
      Valor: [item && item.texto ? item.desconto : false],
      Texto: [item && item.texto ? item.texto : false],
      IdRetencao: [item && item.idRetencao ? item.idRetencao : 0],
      idRealizacaoInscricao: [
        item && item.idRealizacaoInscricao ? item.idRealizacaoInscricao : 0,
      ],
      IdProcessoArtigo: [
        item && item.idProcessoArtigo ? item.idProcessoArtigo : 0,
      ],
      IdRenovavelClienteRenovacaoArtigo: [
        item && item.idRenovavelClienteRenovacaoArtigo
          ? item.idRenovavelClienteRenovacaoArtigo
          : 0,
      ],
      idArtigoRenovavelClienteData: [
        item && item.idArtigoRenovavelClienteData
          ? item.idArtigoRenovavelClienteData
          : 0,
      ],
    });
  }

  retornarPrecoFront(
    artigo: ArtigosFacturacao,
    precoDefault: number
  ): number  {
    precoDefault = (precoDefault && precoDefault>0) ? precoDefault : 1;
    let precos = artigo?.precos?.filter(p=>p.idEmpresa == this.empresa?.idEmpresa)??[];
    return this._doccalculoFront.retornarPrecoArtigo(precos, precoDefault);
  }

  aoClicarCodArtigo() {
    this.artigosFAAutoComplete = [...this.artigosFA];
  }
  async selecArtigo(artigo?: ArtigosFacturacao, index?: number) {
    if (!this.cliente && !this.docCorrenteTemp) {
      this._notificacao.notificar("Seleccione um cliente", false, 5000);
      this.Itens.controls[index].get("CodArtigo").setValue("");
      return;
    }

    this.codMoedaPrincipalCliente =
      this.cliente && this.cliente?.codMoeda
        ? this.cliente?.codMoeda
        : this.docCorrenteTemp && this.docCorrenteTemp.codMoeda
        ? this.docCorrenteTemp.codMoeda
        : null;

    let precoArtigoFront = this.retornarPrecoFront(artigo, this.cliente?.precoDefault);

    this.Itens.controls[index].get("Separador").setValue(false);
    this.Itens.controls[index].get("Texto").setValue(false);
    this.Itens.controls[index].get("IdArtigo").setValue(artigo.idArtigo);
    this.Itens.controls[index].get("CodArtigo").setValue(artigo.codArtigo);
    if (artigo.geridoPorStocks) {
      this.Itens.controls[index].get("geridoPorStocks").setValue(true);
      this.Itens.controls[index].get("valorgeridoPorStocks").setValue("los");
    } else if (!artigo.geridoPorStocks) {
      this.Itens.controls[index].get("geridoPorStocks").setValue(false);
      this.Itens.controls[index].get("valorgeridoPorStocks").setValue("N");
    } else {
      this.Itens.controls[index].get("geridoPorStocks").setValue(false);
      this.Itens.controls[index].get("valorgeridoPorStocks").setValue("");
    }
    this.Itens.controls[index].get("idRealizacaoInscricao").setValue("0");
    this.Itens.controls[index].get("CodUnidade").setValue(artigo.codUnidade);
    this.Itens.controls[index].get("Descricao").setValue(artigo.artigo);
    this.Itens.controls[index].get("IdRetencao").setValue(artigo.idRetencao);
    this.Itens.controls[index].get("Preco").setValue(this.currencyPipe.transform(Util.convertToFloat(precoArtigoFront), "", ""));
  

    this.Itens.controls[index]
      .get("DescricaoIva")
      .setValue(artigo.descricaoIva);

    if (artigo && artigo.codIva) {
      this.Itens.controls[index]
        .get("taxaImposto")
        .setValue(artigo.taxaImposto);
    } else {
      // aq31
      this.Itens.controls[index]
        .get("taxaImposto")
        .setValue(artigo?.taxaIva ? artigo?.taxaIva : "");

      // this.Itens.controls[index].get('taxaImposto').setValue(null);
      this.validarItemControl("taxaImposto", index);
    }
    if (!this.Itens.controls[index].get("taxaImposto").value) {
      this.validarItemControl("taxaImposto", index);
    }

    // this.Itens.controls[index].get('IdImposto').setValue(artigo?.idImposto? artigo?.idImposto: null);
    this.Itens.controls[index]
      .get("IdImposto")
      .setValue(artigo?.idImposto ? artigo?.idImposto : null);
    this.Itens.controls[index]
      .get("Quantidade")
      .setValue(this.currencyPipe.transform(1, "", ""));
    this.Itens.controls[index]
      .get("Desconto")
      .setValue(this.currencyPipe.transform(0, "", ""));
    this.Itens.controls[index]
      .get("DescontoPerc")
      .setValue(this.currencyPipe.transform(0, "", ""));
  }
  
  filtrarArtigoFA(event: any, opcao: number) {
    const termo = event.target.value;
    if (opcao === 1) {
      this.artigosFAAutoComplete = this.artigosFA.filter(
        (x) =>
          (x.codArtigo &&
            x.codArtigo.toLowerCase().includes(termo.toLowerCase())) ||
          (x.artigo && x.artigo.toLowerCase().includes(termo.toLowerCase()))
      );
    }
  }

  validarItemControl(controlo, indice) {
    if (controlo === "Preco") {
      this.Itens.controls[indice]
        .get(controlo)
        .setValidators([Validators.min(1), Validators.required]);
    } else {
      this.Itens.controls[indice]
        .get(controlo)
        .setValidators([Validators.required]);
    }
    this.Itens.controls[indice]
      .get(controlo)
      .updateValueAndValidity({ onlySelf: true });
    this.Itens.controls[indice].get(controlo).markAsTouched({ onlySelf: true });
  }
  
  alterarLinhaItem(item: any, index: number) {
    this.Itens.controls[index]
      .get("Desconto")
      .setValue(
        this.currencyPipe.transform(Util.convertToFloat(item.desconto), "", "")
      );
    this.Itens.controls[index]
      .get("imposto")
      .setValue(
        this.currencyPipe.transform(Util.convertToFloat(item.imposto), "", "")
      );
    this.Itens.controls[index]
      .get("Total")
      .setValue(
        this.currencyPipe.transform(Util.convertToFloat(item.total), "", "")
      );
    this.Itens.controls[index]
      .get("TotalGeral")
      .setValue(
        this.currencyPipe.transform(
          Util.convertToFloat(item.totalGeral),
          "",
          ""
        )
      );
    this.Itens.controls[index]
      .get("SubTotal")
      .setValue(
        this.currencyPipe.transform(Util.convertToFloat(item.subTotal), "", "")
      );
  }

  async alterarValoresIdItem(itens: any): Promise<any> {
    itens.forEach((element, index) => {
      this.Itens.controls[index].get("IdItem").setValue(index + 1);
    });

    return this.Itens.value;
  }
}
